import { createFileRoute, redirect } from "@tanstack/react-router"

import { rpc } from "../lib/rpc.ts"
import { Layout } from "./-components/Layout.tsx"

export const Route = createFileRoute("/$owner/")({
  component: RouteComponent,
  async beforeLoad(opts) {
    const { owner } = opts.params

    const response = await rpc.accounts[":login"].$get({
      param: { login: owner },
    })

    if (response.status === 404)
      throw {
        response,
      } satisfies ErrorComponent.Props["error"]

    const json = await response.json()
    // follow redirect (AccountRedirect/OrganizationRedirect)
    if (json.login !== owner)
      throw redirect({ to: "/$owner", params: { owner: json.login } })

    return {
      owner: json,
    }
  },
  errorComponent(props) {
    return <ErrorComponent {...props} />
  },
})

function RouteComponent() {
  const { owner } = Route.useRouteContext()

  return (
    <Layout direction="vertical">
      <Header owner={owner} />

      <Layout.Content>
        <Layout.Empty title="Coming soon">TODO</Layout.Empty>
      </Layout.Content>
    </Layout>
  )
}

function Header(props: {
  owner?: Layout.Breadcrumb.Props["repositoryOwner"] | undefined
}) {
  const { owner } = props
  return (
    <Layout.Header showLogo={false}>
      {owner && <Layout.Breadcrumb repositoryOwner={owner} />}
    </Layout.Header>
  )
}

function ErrorComponent(props: ErrorComponent.Props) {
  const { error } = props
  const { owner } = Route.useParams()

  if ("response" in error)
    return (
      <Layout direction="vertical">
        <Header />

        {/* <Layout.Body> */}
        <Layout.Content>
          {error.response.status === 404 ? (
            <Layout.Empty title="Account not found">
              The account <code>{owner}</code> does not exist, or has not been
              set up with GitChat yet.
            </Layout.Empty>
          ) : (
            <Layout.Empty title="An error occurred">
              An error occurred while loading the account.
            </Layout.Empty>
          )}
        </Layout.Content>
        {/* </Layout.Body> */}
      </Layout>
    )

  return (
    <Layout direction="vertical">
      {/* <Layout.Body> */}
      <Layout.Content>
        <Layout.Empty title="Something went wrong">
          {error.message}
        </Layout.Empty>
      </Layout.Content>
      {/* </Layout.Body> */}
    </Layout>
  )
}

declare namespace ErrorComponent {
  type Props = {
    error: Error | { response: Response }
  }
}
